import { z } from 'zod';
import { servicesProviderPricingCodeOnlySchema, servicesProviderPricingCodeOnlyDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

/**
 * This is the service that handles the payout for the coverage product to the vendor (i.e. the provider -- example: McGraw)
 * We keep the coverage retail cost for this service and then it is paid to the coverage providers async
 * @example Payout breakdown:
 * - Coverage retail cost: $100
 * - Coverage markup: $10 (40% Ekho, 60% Dealer)
 * - Coverage tax: $5
 * - Coverage payout to vendor service (coverage_vendor): $100
 */
// ============================================================================
// Pricing Schemas
// ============================================================================
const coverageVendorServicePricingSchema = servicesProviderPricingCodeOnlySchema;
const coverageVendorServicePricingDtoSchema = servicesProviderPricingCodeOnlyDtoSchema;
// ============================================================================
// Core Schema
// ============================================================================
const coverageVendorServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(coverageVendorServicePricingSchema),
});
// ============================================================================
// DTO Schema
// ============================================================================
const coverageVendorServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(coverageVendorServicePricingDtoSchema),
});

export { coverageVendorServiceConfigDtoSchema, coverageVendorServiceConfigSchema, coverageVendorServicePricingDtoSchema, coverageVendorServicePricingSchema };
//# sourceMappingURL=CoverageVendorServiceConfig.js.map
